/**
 * Debug logging that reaches the console only in development builds, so
 * request and session details never print in users' browsers.
 *
 * Real problems should still use console.warn / console.error directly.
 */
const enabled = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]): void => {
    if (enabled) console.log(...args);
  },
};
